import React, { ReactNode } from 'react'

import OptionsMenu, {
  OptionProps,
  OptionsMenuProps
} from 'components_new/molecules/OptionsMenu'

import { TChartClick } from './types'

type TClickBase = { position?: { left: number; top: number } }

interface ChartOptionsMenuProps<TClick extends TClickBase = TChartClick>
  extends Pick<OptionsMenuProps, 'onClose' | 'open'> {
  clicked: TClick
  options: OptionProps[] | ((payload: TClick) => OptionProps[])
  renderBody?: (clicked: TClick) => ReactNode
  title?: string
}

const ChartOptionsMenu = <TClick extends TClickBase = TChartClick>(
  props: ChartOptionsMenuProps<TClick>
) => {
  const { clicked, options, renderBody, title, ...rest } = props

  const defaultClicked = clicked as unknown as TChartClick

  const resolvedOptions =
    typeof options === 'function' ? options(clicked) : options

  return (
    <OptionsMenu
      anchorPosition={clicked.position}
      anchorReference="anchorPosition"
      body={renderBody ? renderBody(clicked) : null}
      options={resolvedOptions}
      title={title ?? defaultClicked.label}
      {...rest}
    />
  )
}

export default ChartOptionsMenu
